import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppJumpRound = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 24,
			cy: 24,
			r: 24,
			fill: "#FAED6F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#002A2A",
			d: "m28.713 23.536-6.962-3.482a.52.52 0 0 0-.751.465v6.962a.52.52 0 0 0 .751.464l6.962-3.48a.52.52 0 0 0 0-.93Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#002A2A",
			fillRule: "evenodd",
			d: "M27.429 12.857c0-.473.383-.857.857-.857H35a1 1 0 0 1 1 1v6.714a.857.857 0 0 1-1.714 0v-4.83l-3.787 3.786a.857.857 0 0 1-1.212-1.212l3.744-3.744h-4.745a.857.857 0 0 1-.857-.857Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#002A2A",
			fillRule: "evenodd",
			d: "M35.143 24c.473 0 .86.385.827.857C35.53 31.085 30.34 36 24 36c-6.627 0-12-5.373-12-12 0-6.34 4.915-11.53 11.143-11.97.472-.033.857.354.857.827 0 .474-.385.854-.857.893-5.28.435-9.429 4.858-9.429 10.25 0 5.68 4.605 10.286 10.286 10.286 5.392 0 9.815-4.15 10.25-9.43.04-.47.42-.856.893-.856Z",
			clipRule: "evenodd"
		})
	]
});
export { SvgAppJumpRound as ReactComponent };
